import { RpcError } from "grpc-web";

// Helpers
import { getApiToken } from "../helpers";
import { getBffRequest } from "./base/api";

// Protos
import { ClaimsBFFControllerClient } from "./protos/Claims-bffServiceClientPb";
import {
	GetClaimReportsRequest,
	GetClaimReportsResponse,
	ImportClaimReportsRequest,
	ImportClaimReportsResponse
} from "./protos/messages/claims.message_pb";

export const getClaimReports = async (claimId: number): Promise<GetClaimReportsResponse> => {
	const token: string = getApiToken();

	const request = new GetClaimReportsRequest();
	request.setClaimId(claimId);

	const client: ClaimsBFFControllerClient = getBffRequest(token);
	return client
		.getClaimReports(request, {})
		.then((response: GetClaimReportsResponse) => response)
		.catch((err: RpcError) => {
			console.error(err);
			throw err;
		});
};

export const importClaimReports = async (csvFile: File): Promise<ImportClaimReportsResponse> => {
	const token: string = getApiToken();

	const csvData = new Uint8Array(await csvFile.arrayBuffer());
	const request = new ImportClaimReportsRequest();
	request.setCsvData(csvData);

	const client: ClaimsBFFControllerClient = getBffRequest(token);
	return client
		.importClaimReports(request, {})
		.then((response: ImportClaimReportsResponse) => response)
		.catch((err: RpcError) => {
			console.error(err);
			throw err;
		});
};
